import type { Translation } from "../hooks/useTranslations";
import { Notification, NotificationType } from "../http/types/notifications";

export type NotificationEntry = {
  key: string;
  isInvite: boolean;
  label: string;
  // the page where the user answers it
  path: string;
};

// a single-module app has no projects pages: it shows only the calculation notifications
const SINGLE_MODULE_APP_TYPES: NotificationType[] = ["calculation_sharing_request", "calculation_sharing_invite"];

const getPath = (notification: Notification): string => {
  switch (notification.type) {
    case "project_sharing_request":
      return `/project-sharing-requests/${notification.id}`;
    case "calculation_sharing_request":
      return `/calculation-sharing-requests/${notification.id}`;
    case "project_sharing_invite":
      return `/invite/${encodeURIComponent(notification.token ?? "")}`;
    case "calculation_sharing_invite":
      return `/calculation-invite/${encodeURIComponent(notification.token ?? "")}`;
  }
};

const getLabel = (translation: Translation, notification: Notification): string => {
  const t = translation.notifications;
  const { firstName, lastName, email } = notification.user;
  const user = [firstName, lastName].filter(Boolean).join(" ") || email;
  const resource = notification.resource.name;
  switch (notification.type) {
    case "project_sharing_request":
      return t.projectSharingRequest(user, resource);
    case "calculation_sharing_request":
      return t.calculationSharingRequest(user, resource);
    case "project_sharing_invite":
      return t.projectSharingInvite(user, resource);
    case "calculation_sharing_invite":
      return t.calculationSharingInvite(user, resource);
  }
};

/** The notifications as menu entries, the ones of this app only */
export const toNotificationEntries = (
  notifications: Notification[],
  translation: Translation,
  isSingleModuleApp: boolean,
): NotificationEntry[] =>
  notifications
    .filter((notification) => !isSingleModuleApp || SINGLE_MODULE_APP_TYPES.includes(notification.type))
    .map((notification) => ({
      key: `${notification.type}-${notification.id}`,
      isInvite: notification.type === "project_sharing_invite" || notification.type === "calculation_sharing_invite",
      label: getLabel(translation, notification),
      path: getPath(notification),
    }));
